/* eslint-disable react/no-did-mount-set-state */
/* eslint-disable max-lines */
/* eslint-disable no-nested-ternary */
/* global window */
import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import Auth from '../../Auth';
import { connect } from 'react-redux';
import withRouter from 'HOCs/withRouter';
import { get } from '../../server';
import { FormattedMessage as Translation } from 'react-intl';
import { urls as categoryUrls, CATEGORY_REQUIRED_HEADERS } from 'Reducers/categories';
import { statusCodes } from 'Helpers/http';
import { decryptHash } from 'Helpers/parser';
import { canBeFeatured } from 'Helpers/limitAdStatus';
import { getFavouriteItemInfo, verifyRedirectionParameters } from 'Helpers/track';
import { Helmet } from 'react-helmet-async';
import { getItemUrlMobbi, getItemUrl } from 'Helpers/url';
import { css as uiCss, FullPageLoader } from 'panamera-react-ui';
import SubHeader from 'Components/SubHeader/AsyncSubHeader.APP_TARGET';
import ReportModal from 'Components/ReportModal/AsyncReportModalContainer';
import ItemSEO from './components/ItemSEO/ItemSEO';
import SocialMetaTags from 'Components/SEO/SocialMetaTags';
import AdvertisingComponent from 'Components/AdvertisingComponent/AdvertisingComponent';
import ServerContext from 'Components/ServerContext/ServerContext';
import NoResults from 'Components/NoResults/NoResults';
import FirstTimeUserTips from 'Components/FirstTimeUserTips/AsyncFirstTimeUserTips';
import Notifications from './components/Notifications/AsyncNotifications';
import setLoginModalState from 'Actions/setLoginModalState';
import css from './Item.scss';
import ItemContent from './ItemContent';
import { urls as itemUrls } from 'Reducers/items';
import { urls as userUrls } from 'Reducers/users';
import { getCategoryTree } from 'Reducers/componentHelpers';
import { addressComponentsToString, getCityLocationId } from 'Helpers/locations';
import { routerParamsToSeoQuery } from 'Helpers/listing';
import { getUserFavouritesIds } from 'Actions/user';
import { getItemDetail as getItem } from 'Actions/item';
import Footer from 'Components/Footer/Footer';
import ItemLeadForm from './components/ItemLeadForm/AsyncItemLeadForm';
import Page from 'Components/Page/Page';
import Placeholder from './components/Placeholder/Placeholder.APP_TARGET';
import withTrack from 'HOCs/withTrack/withTrack';
import withMessage from 'HOCs/withMessage/withMessage';
import { withConfig } from 'HOCs/withConfig/withConfig';
import withTags from 'HOCs/withTags/withTags';
import Breadcrumb from 'Components/Breadcrumb/Breadcrumb';
import SearchHeader from '../../components/HeaderWrapper/Headers/SearchHeader/SearchHeader.APP_TARGET';
import {
    getUserDataSelector
} from 'Selectors/user';
import { getCategoryElement } from 'Selectors/categories';
import { getLocationByLatLongFromCollection, selectedLocationSelector } from 'Selectors/location';
import { itemBreadcrumbSelector } from 'Selectors/breadcrumb';
import {
    recommendationsSelector,
    itemsMetadataSelector,
    getItemStructuredData,
    isFetchingItemDetail,
    selectAdpvGalleryImages,
    getUrlType,
    adpvFeatureStatusSelector
} from 'Selectors/items';
import { scrollToTop } from 'Helpers/page';
import { leadFormConfigSelector } from 'Selectors/leadForm';
import { getLeadFormName, checkIfLoginMandatory } from 'Helpers/leadForm';
import lazyLoad from 'Components/asyncLoading/lazyLoad';
import CardLoading from 'Components/asyncLoading/CardLoading';
import withDataFetching from 'HOCs/withDataFetching/withDataFetching';
import { getNavigationTree } from 'Actions/navigationTree';
import { setOriginSync, setFlowStep } from 'Actions/track';
import JsonLd from 'Components/SEO/JsonLd';
import { configSelector, getEscrowConfig, getVasConfigValues } from 'Selectors/config';
import {
    ITEM_TAP_REPORT_AD,
    VIEW_ITEM, ITEM_TAP_IMAGE,
    ITEM_TAP_IMAGE_MINIMIZE,
    ITEM_TAP_IMAGE_PAGINATION,
    VIEW_ITEM_TIME,
    VIEW_LISTINGS_RESULTS_SUMMARY,
    FLOW_STEP,
    FLOW_TYPE,
    CAR_COMPARE_FLOW_STEP,
    ESCROW_TRACK
} from 'Constants/tracking';
import {
    ITEM_SOURCE,
    ITEMS_SEARCH_SOURCE,
    APIVERSION,
    BREADCRUMB_SEPARATOR_SIZE,
    RESULTSET_TYPE,
    INSPECTION_INFO_STATUS
} from 'Constants/items';
import { isEmpty } from 'Helpers/objects';
import classNames from 'classnames';
import { getQuickFiltersByName } from 'Selectors/filtersTanak';
import { TrackerOrigins } from 'Components/TrackerProvider/TrackerProvider';
import { SELLER_ACTIONS } from 'Helpers/myAdsActionFactory';
import { put } from 'Server';
import TrustTagBottomSheetAsync from 'Components/TrustTagBottomSheet/TrustTagBottomSheetAsync.APP_TARGET';
import { trustTagHash } from 'Constants/listing';
import OLXAutosHeaderWrapper from './../../olxautos/components/OLXAutosHeaderWrapper/OLXAutosHeaderWrapper.APP_TARGET';
import { BACKGROUND2, WHITE_TEXT } from 'Constants/colors';
import {
    getIsSelfInspectedCar,
    getIsStoreInspectedCar,
    getItemTrackingInfo,
    getIsFeaturedAd,
    getItemCounts,
    isCocoFofoUser,
    getHiddenTitle,
    isCocoUser
} from 'Helpers/item';
import { PLATFORM, IS_MOBILE } from 'Constants/device.APP_TARGET';
import { LayoutSelector, LayoutHelper, TrackingHelper } from 'olx-autos-landing-page';
import withLocation from 'HOCs/withLocation/withLocation';
import { isMobile } from 'Helpers/devices';
import { LAMUDI_ADPV_BANNER_DESKTOP } from 'Constants/imageUrls';
import LamudiBrandingAsync from 'Components/LamudiBranding/LamudiBrandingAsync';
import cssLamudi from 'Components/LamudiBranding/LamudiBranding.scss';
import { showLamudiBranding } from 'Helpers/lamudiHelper';
import { getIsCategoryDeprecated } from 'Helpers/categories';
import Icon from 'Components/ThematicIcon/ThematicIcon';
import { CATEGORIES_IDS } from 'Constants/categories';
import { withSchema } from 'HOCs/withSchema/withSchema';
import { getItem as getSessionStorageItem, removeItem as removeSessionStorageItem } from 'Helpers/sessionStorage';
import { URL } from 'Constants/baseUrl';
import { slugify } from 'Helpers/strings';
import { isReservationButtonActive } from 'Helpers/reservationButton';
import { isSpotLight, isFeatured } from 'Helpers/adActionStatus';

// Actions
import { fetchEscrowConfiguration } from 'Actions/s3Config';
import BookingModal from './components/BookingModal/BookingModal';
import AlreadyExistModal from './components/AlreadyExistModal/AlreadyExistModal';
import setToastMessageState from 'Actions/setToastMessageState';

const getLatLon = item => {
    const { lat, lon } = (item && item.metadata && item.metadata.locations && item.metadata.locations[0]) || {};

    return { lat, lon };
};
const { grid } = uiCss;

const getRelevanceTrackInfo = ({ item, itemsMetadata, isAdSuggested: ad_suggested }) => {
    const { key: spell_key = null, version: spell_version = null } = (item && item.spell) || {};
    const {
        feed_version = null,
        original_term: search_string,
        suggested_term: search_string_suggested,
        resultset_id
    } = itemsMetadata || {};

    return {
        spell_key,
        spell_version,
        feed_version,
        search_string,
        search_string_suggested,
        ad_suggested,
        resultset_id
    };
};

const BoostAd = lazyLoad({
    loader: () => import(/* webpackChunkName: "item-seller-cards" */'./components/BoostAd/BoostAd'),
    loading: CardLoading
});

const PostNowCard = lazyLoad({
    loader: () => import(/* webpackChunkName: "item-seller-cards" */'./components/PostNowCard/PostNowCard'),
    loading: CardLoading
});

const AppliedBoostAd = lazyLoad({
    loader: () => import(/* webpackChunkName: "item-seller-cards" */'./components/AppliedBoostAd/AppliedBoostAd'),
    loading: CardLoading
});

const StatisticsCard = lazyLoad({
    loader: () => import(/* webpackChunkName: "item-seller-cards" */'./components/StatisticsCard/StatisticsCard'),
    loading: CardLoading
});

const SpotlightAd = lazyLoad({
    loader: () => import(/* webpackChunkName: "item-seller-cards" */'./components/SpotlightAd/SpotlightAd'),
    loading: CardLoading
});

const TIME_FACTOR = 1000;
const ADDRESS_LIMIT = 3;

export class Item extends React.Component {
    static propTypes = {
        breadcrumbLinks: PropTypes.array.isRequired,
        marketConfig: PropTypes.shape({
            get: PropTypes.func.isRequired
        }).isRequired,
        getItem: PropTypes.func,
        item: PropTypes.object,
        location: PropTypes.object,
        isFetchingItem: PropTypes.bool,
        favoriteIt: PropTypes.func,
        removeFavorite: PropTypes.func,
        params: PropTypes.object,
        getMeta: PropTypes.func,
        meta: PropTypes.func,
        categoryTreeSelected: PropTypes.object,
        config: PropTypes.object,
        category: PropTypes.object,
        isErrorItem: PropTypes.bool,
        trackFilters: PropTypes.object,
        trackFiltersMetadata: PropTypes.object,
        trackOrigin: PropTypes.string,
        router: PropTypes.object,
        setLoginModalState: PropTypes.func,
        isFullItem: PropTypes.bool,
        user: PropTypes.object,
        track: PropTypes.func.isRequired,
        trackerOrigins: PropTypes.object.isRequired,
        selectedLocation: PropTypes.shape({
            id: PropTypes.number,
            latitude: PropTypes.number,
            longitude: PropTypes.number
        }),
        autocomplete: PropTypes.object,
        leadFormConfigData: PropTypes.object,
        structuredData: PropTypes.object,
        filterInteraction: PropTypes.string,
        selectFrom: PropTypes.string,
        itemsMetadata: PropTypes.object.isRequired,
        quickFilters: PropTypes.string,
        setOriginTrack: PropTypes.func,
        isInspectionPosting: PropTypes.bool,
        editItem: PropTypes.func,
        getItemSeller: PropTypes.func,
        addressLocation: PropTypes.object,
        vasConfigValues: PropTypes.arrayOf(PropTypes.object),
        footer: PropTypes.array,
        recommendations: PropTypes.array,
        browseMode: PropTypes.string,
        trafficOrigin: PropTypes.string,
        source: PropTypes.string,
        onViewRelatedAd: PropTypes.func,
        allItemImages: PropTypes.array,
        trackingOrigin: PropTypes.string,
        userType: PropTypes.string,
        setFlowStepTrack: PropTypes.func,
        app: PropTypes.shape({
            location: PropTypes.shape({
                pathname: PropTypes.string,
                search: PropTypes.string
            })
        }),
        showAkakceBotHiddenTitle: PropTypes.bool,
        videoAvailableVariant: PropTypes.string,
        isShowCoachMark: PropTypes.bool,
        isReservationButtonActive: PropTypes.bool,
        getItemAd: PropTypes.func,
        fetchEscrowConfiguration: PropTypes.func,
        getEscrowConfig: PropTypes.object,
        escrowDetails: PropTypes.object,
        getRelationshipValidation: PropTypes.func,
        setToastMessageState: PropTypes.func,
        sendChatMessage: PropTypes.func,
        loggedUser: PropTypes.object
    };

    static defaultProps = {
        isFetchingMonetizer: true,
        monetizerItem: {},
        wallet: {},
        params: {},
        trackFilters: {},
        trackFiltersMetadata: {},
        trackOrigin: TrackerOrigins.DIRECT,
        isFullItem: false,
        selectedLocation: {},
        autocomplete: {},
        leadFormConfigData: {},
        selectFrom: ITEM_SOURCE.DIRECT,
        itemsMetadata: {},
        vasConfigValues: [],
        userType: '',
        videoAvailableVariant: '',
        sendChatMessage: () => {}
    };

    static fetchData(dispatch, renderProps, { baseUrl, headers }, options) {
        const { user, config } = options;
        const promises = [];
        let { id, hash } = renderProps.params;

        if (!id && hash) {
            id = decryptHash(hash);
        }

        const shouldShowDentMap = config.showDentMap;
        const itemsApiVersion = shouldShowDentMap ? APIVERSION.V3 : APIVERSION.V2;

        promises.push(
            dispatch(
                get(
                    `${baseUrl}${categoryUrls.getCategories}`,
                    'CATEGORIES',
                    {},
                    { ...headers, ...CATEGORY_REQUIRED_HEADERS }
                )
            )
        );

        // if (config?.financeConfigCode) {
        //     promises.push(dispatch(
        //         get(
        //             `${baseUrl}${'/api/config/pre-approval'}`,
        //             'FINANCE_CONFIG',
        //             {},
        //             {
        //                 'client-id': 'olx-consumer'
        //             }
        //         )
        //     ));
        // }

        if (config && config.adpvAuto && config.adpvAuto.showFavBtn) {
            promises.push(dispatch(getUserFavouritesIds(baseUrl, headers)));
        }

        if (user) {
            promises.push(
                dispatch(get(`${baseUrl}${userUrls.getMeta(user.id)}`, 'USERS', {}, headers))
            );
        }

        promises.push(dispatch(getItem(id, itemsApiVersion, config?.lang)));

        return Promise.all(promises);
    }

    constructor(props) {
        super(props);
        const olxAutosConfig = props.marketConfig.get('olxAutos');

        this.enableLeadFor = props.marketConfig.get('reProjects', 'enableLeadForm');
        this.enableChat = props.marketConfig.get('adpvAuto', 'enableChat');
        this.enableReportAd = props.marketConfig.get('adpvAuto', 'enableReportAd');
        this.showMXDesign = props.marketConfig.get('adpvAuto', 'showMXDesign') || props.marketConfig.get('adpvAuto', 'showNewDesign');
        this.showModernDesign = props.marketConfig.get('showModernDesign');
        this.state = {
            openReportModal: false,
            loggedUser: Auth.getUser(),
            isRedirecting: this.wasCalledInAnIframe(),
            showTips: false,
            tipsInitiationPoint: '',
            callFuncStr: '',
            messageSend: false,
            blockFavorite: false,
            leadFormName: '',
            openLeadFormFlow: false,
            source: '',
            actionCallback: () => { },
            loginSuccess: false,
            updateNoticationMessage: false,
            action: '',
            isLoginMandatory: false,
            isShowCoachMark: false,
            showBookingModal: false,
            showAlreadyExistModal: false,
            isLoading: false
        };

        this.leadFormActions = ['adDetailOnTapChat', 'adDetailOnTapCall'];
        this.impressions = [];

        this.breadcrumbSpearator = this.showMXDesign ? <Icon icon="arrowRight" size={ BREADCRUMB_SEPARATOR_SIZE[PLATFORM] } /> : '/';
        this.carsCategory = props.marketConfig.get('adpvAuto', 'carCategory');
        this.imageViewed = {};
        this.imageSwipeCount = 0;
        this.fullScreenImageSwipeCount = 0;
        this.relatedAdsImpressions = {};
        this.headerRef = createRef();
        this.subHeaderRef = createRef();
        this.headerLogoRef = createRef();
        this.isMxCl = olxAutosConfig && olxAutosConfig.isMXCL || false;
        this.disableRealEstateBoost = props.marketConfig.get('disableRealEstateBoost');
        this.isBusinessUser = props.user?.is_business;
        this.lamudiCheck = this.disableRealEstateBoost && this.isBusinessUser && CATEGORIES_IDS.RE_PROPERTIES.indexOf(props.item.category_id) !== -1;
        this.showNewLeadForm = this.props.marketConfig.get('olxAutos', 'showNewLeadForm');
        this.showCLAIntentCTAs = this.props.marketConfig.get('olxAutos', 'showCLAIntentCTAs');
        this.isOlxMobbi = this.props.marketConfig.get('isOlxMobbi');
    }

    componentDidMount() {
        if (this.isMyItem()) {
            this.props.getItemAd();
        }
        if (this.props.item) {
            this.viewItemAnalytics();
            this.reservationCoachMark();
        }

        if (this.props.isFullItem) {
            this.initializeTracking();
        }
        else {
            this.props.getItem().then(() => {
                this.initializeTracking();
                this.reservationCoachMark();
            });
        }

        if (this.state.loggedUser) {
            if (this.props.meta(this.state.loggedUser.id) === undefined) {
                this.props.getMeta(this.state.loggedUser.id);
            }
        }

        if (typeof window !== 'undefined') {
            window.addEventListener('beforeunload', () => {
                this.trackViewItemTime(this.props);
            });
        }

        const seoConfig = this.props.marketConfig.get('SEO');

        if (this.props.isErrorItem) {
            if (seoConfig.trackNoResults) {
                this.props.track('view_item_invalid');
            }
        }
        if (this.enableLeadFor) {
            this.getLeadformName();
            this.checkIfLoginMandatory();
        }

        this.startTime = Date.now();
        this.props.setFlowStepTrack(TrackerOrigins.ITEM_PAGE);
        this.props.fetchEscrowConfiguration();
    }

    componentDidUpdate(prevProps) {
        const prevItemId = prevProps.item && prevProps.item.id;
        const itemId = this.props.item && this.props.item.id;
        const sameId = prevItemId === itemId;
        const { trackerOrigins, setOriginTrack } = this.props;

        if (!sameId
            && !this.props.isFullItem
            && !this.props.isFetchingItem
            && !this.props.isErrorItem
        ) {
            this.trackViewItemTime(prevProps);
            setOriginTrack(trackerOrigins.ITEM_PAGE);
            this.props.getItem(itemId).then(() => {
                this.startTime = Date.now();
                this.initializeTracking();
            });
            scrollToTop();
            this.reservationCoachMark();
        }

        if (!sameId && this.props.isFullItem) {
            this.trackViewItemTime(prevProps);
            this.startTime = Date.now();
            setOriginTrack(trackerOrigins.ITEM_PAGE);
            this.initializeTracking();
        }

        if (prevItemId && !sameId && !this.props.isFetchingItem && !this.props.isErrorItem) {
            this.fireViewItemSummary(prevProps);
        }

        if (this.enableLeadFor
            && (
                (!prevProps.leadFormConfigData.form_config && this.props.leadFormConfigData.form_config)
                || (!sameId && itemId)
            )
        ) {
            this.getLeadformName(this.props);
            this.checkIfLoginMandatory(this.props);
        }
    }

    componentWillUnmount() {
        const {
            trackerOrigins,
            setOriginTrack
        } = this.props;

        window.removeEventListener('beforeunload', this.trackViewItemTime(this.props));
        setOriginTrack(trackerOrigins.ITEM_PAGE);
        this.fireViewItemSummary();
    }

    getItemParameter = key => {
        const itemParam = this.props.item.parameters;
        const foundItem = itemParam?.find(item => item.key === key);

        return foundItem ? foundItem.formatted_value : '';
    }

    getItemName = () => {
        const make = this.getItemParameter('make');
        const type = this.getItemParameter('m_tipe');
        const year = this.getItemParameter('m_year');

        if (!(make && type && year)) {
            return this.props.item.title;
        }

        const itemNameArr = [make, type, year && `(${year})`].filter(Boolean);

        return itemNameArr.join(' ');
    }

    getItemCategory = () => {
        if (this.isOlxMobbi) {
            return this.props.categoryTreeSelected?.L2?.name ?? '';
        }
        const itemCategoryArr = Object.values(this.props.categoryTreeSelected).map(item => item?.name);

        return itemCategoryArr.join(' - ');
    }

    getItemPrice = () => {
        const { item } = this.props;

        return item?.price?.value?.raw || this.getItemParameter('salary_to') || 0;
    }

    reservationCoachMark = () => {
        if (typeof window !== 'undefined') {
            // Retrieve 'reservationCoachMark' value from localStorage flag for show coachmark reservation if user first visit adpv
            const reservationCoachMark = window.localStorage.getItem('reservationCoachMark');
            const isShowReservationButton = isReservationButtonActive(
                this.props?.item?.escrow_details?.is_escrow_enabled ?? false,
                this.state.loggedUser?.id ?? null,
                this.props?.item?.user_id ?? null,
                this.props?.getEscrowConfig,
                this.props?.item?.category_id ?? null
            );

            // reservation button & coachmark only show when item is_escrow_enabled & only 3 categories used car, handphone & used motorcylces
            if ((!reservationCoachMark || reservationCoachMark === 'false')
                && isShowReservationButton) {
                this.setState({ isShowCoachMark: true });
            }
            else {
                this.setState({ isShowCoachMark: false });
            }
        }
    }

    viewItemAnalytics = () => {
        const { item } = this.props;

        if (typeof window !== 'undefined') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: 'view_item',
                feature: this.isOlxMobbi ? 'beli mobil' : 'cari iklan',
                bahan_bakar: this.getItemParameter('m_fuel')?.toLowerCase() || 'na',
                tahun: this.getItemParameter('m_year') || 'na',
                kilometer: this.getItemParameter('mileage')?.toLowerCase() || 'na',
                transmisi: this.getItemParameter('m_transmission')?.toLowerCase() || 'na',
                penjual: this.getItemParameter('m_seller_type')?.toLowerCase() || 'na',
                lokasi: this.getLocationPath(2)?.toLowerCase() || 'na',
                kapasitas_mesin: this.getItemParameter('m_engine_capacity')?.toLowerCase() || 'na',
                ecommerce: {
                    currency: 'IDR',
                    items: [
                        {
                            item_id: item?.id,
                            item_name: this.getItemName()?.toLowerCase() || 'na',
                            price: this.getItemPrice(),
                            item_brand: this.getItemParameter('make')?.toLowerCase() || 'na',
                            item_category: this.getItemCategory()?.toLowerCase() || 'na',
                            item_variant: this.getItemParameter('m_tipe_variant')?.toLowerCase() || 'na',
                            quantity: 1
                        }
                    ]
                }
            });
        }
    };

    initializeTracking = () => {
        const item = this.props.item;

        if (item) {
            this.trackViewItem();
            this.imageViewed[this.props.item.images[0].url] = 1; // for main gallery
            const firstInspReportImgUrl = this.props.item.inspectionDetails?.damageReport?.values[0]?.tags[0].images[0].url;

            if (firstInspReportImgUrl) {
                this.imageViewed[firstInspReportImgUrl] = 1; // for inspection report gallery
            }
        }
    }

    fireViewItemSummary = (prevProps = {}) => {
        const {
            browseMode,
            trafficOrigin,
            source,
            item,
            recommendations,
            allItemImages,
            location
        } = this.props;

        const { source: prevSource, item: prevItem, recommendations: prevRecommendations, allItemImages: prevAllItemImages } = prevProps;

        const trackItem = prevItem || item;
        const trackSource = prevSource || source;
        const trackRecommendations = prevRecommendations || recommendations;
        const trackAllItemImages = prevAllItemImages || allItemImages;

        this.onTrack('view_item_summary', {
            origin: trafficOrigin,
            browsing_mode: browseMode,
            resultset_type: trackSource || browseMode || '',
            page_number: Object.keys(this.imageViewed).length,
            total_page: this.imageSwipeCount,
            ad_inspected: getIsStoreInspectedCar(trackItem?.inspection_info),
            fa_ad: !!getIsFeaturedAd(trackItem),
            time_spent: Math.floor((Date.now() - this.startTime) / TIME_FACTOR),
            adscreen_pagination: this.imageSwipeCount - this.fullScreenImageSwipeCount,
            fullscreen_pagination: this.fullScreenImageSwipeCount,
            images_count: trackAllItemImages?.length,
            select_from: location?.state?.select_from || trackSource
        });

        if (trackRecommendations?.length > 0) {
            const { totalFeaturedAds, totalInspectedAds } = getItemCounts(trackRecommendations);

            const relatedAdsImpressionsItemIds = Object.keys(this.relatedAdsImpressions);

            this.onTrack(VIEW_LISTINGS_RESULTS_SUMMARY, {
                origin: trafficOrigin,
                browsing_mode: browseMode,
                resultset_type: RESULTSET_TYPE.RELATED,
                inspected_ad_count: totalInspectedAds,
                original_ads_count: trackRecommendations.length,
                fa_ad_count: totalFeaturedAds,
                inspected_ad_count_impression: relatedAdsImpressionsItemIds.filter(itemId => this.relatedAdsImpressions[itemId].isInspected).length,
                fa_ad_count_impression: relatedAdsImpressionsItemIds.filter(itemId => this.relatedAdsImpressions[itemId].isFeatured).length,
                result_count_impression: relatedAdsImpressionsItemIds.length,
                time_spent: Math.floor((Date.now() - this.startTime) / TIME_FACTOR),
                select_from: location?.state?.select_from || '',
                ...LayoutHelper.getAcquisitionChannelTrackingValues()
            });
        }

        this.imageViewed = {};
        this.imageSwipeCount = 0;
        this.fullScreenImageSwipeCount = 0;
        this.relatedAdsImpressions = {};
    }

    handleViewRelatedAd = item => {
        this.relatedAdsImpressions[item.id] = item;
    }

    recordItemImpressions = impression => {
        if (!this.impressions.includes(impression)) {
            this.impressions.push(impression);
        }
    }

    getTrackingAttributes = props => {
        const {
            selectedLocation,
            trackFilters,
            category,
            trackOrigin,
            autocomplete,
            selectFrom,
            filterInteraction,
            trackFiltersMetadata,
            item = {},
            itemsMetadata,
            quickFilters,
            location,
            marketConfig,
            adpvFeatureStatus
        } = props;
        const { user_id: seller_id } = item;
        const { longitude: lon, latitude: lat, id } = selectedLocation;
        const { sorting, viewType, ...restTrackFilters } = trackFilters;
        const filters = {
            ...restTrackFilters,
            category: category && category.id
        };

        if (lat && lon && id) {
            filters.location = { lat, lon, id };
        }

        if (trackOrigin === ITEMS_SEARCH_SOURCE) {
            const lastUrl = autocomplete.lastCollectionUrl;
            const lastSearch = autocomplete.collections[lastUrl];

            if (lastSearch && lastSearch.query) {
                filters.text = lastSearch.query.user_query;
            }
        }

        const { inspection_info, monetizationInfo } = item;
        const ad_inspected = !!(getIsStoreInspectedCar(inspection_info)
            && inspection_info.consent === INSPECTION_INFO_STATUS.APPROVED);
        const fa_ad = !!((monetizationInfo && !isEmpty(monetizationInfo.currentProduct))
            || (item.package && (item.package.id || item.package.name)));

        const { relatedAdTracking = {}, featuredAdTracking = {}, fromBundleResultset } = location.state || {};

        const visualizationType = marketConfig.get('visualizationType', PLATFORM);
        const { query } = location || {};
        const redirectionTrackingInfo = verifyRedirectionParameters(query) || {};

        const trackInfo = {
            origin: trackOrigin,
            resultset_type: fromBundleResultset || trackOrigin,
            select_from: location?.state?.select_from || selectFrom,
            seller_id,
            filterInteraction,
            filter_count: isEmpty(restTrackFilters) ? 0 : Object.keys(restTrackFilters).length,
            filters,
            quick_filters: quickFilters,
            sorting_applied: sorting || (itemsMetadata.applied_sorting && itemsMetadata.applied_sorting.key),
            visual_applied: visualizationType,
            ...trackFiltersMetadata,
            ...getRelevanceTrackInfo(this.props),
            ad_inspected,
            fa_ad,
            self_inspected_ad: !!getIsSelfInspectedCar(inspection_info),
            ...relatedAdTracking,
            ...featuredAdTracking,
            ...this.getDealerTypeInfo(),
            ...this.getVasTagsInfo(),
            item_status: adpvFeatureStatus,
            ...redirectionTrackingInfo
        };

        if (viewType) {
            trackInfo.visual_applied = viewType;
        }
        return trackInfo;
    }
    trackViewItemTime = props => {
        if (props && !isEmpty(props.item)) {
            const trackInfo = this.getTrackingAttributes(props);

            trackInfo.time_spent = Math.floor((Date.now() - this.startTime) / TIME_FACTOR); // eslint-disable-line no-magic-numbers
            trackInfo.ad_inspected = false;
            trackInfo.impressions = this.impressions;
            const trackProps = {
                ...getFavouriteItemInfo(props.item),
                ...this.getTrackingInfo(props)
            };

            if (trackProps.item_id) {
                this.props.track(VIEW_ITEM_TIME, { ...trackProps, ...trackInfo });
            }
        }
    }

    getDealerTypeInfo = () => {
        const { user } = this.props;

        if (user && user.dealer && user.dealer.car && user.dealer.car.dealer_type) {
            return {
                credits: this.props.user.dealer.car.dealer_type
            };
        }

        return {};
    }

    getVasTagsInfo = () => {
        if (!this.props.vasConfigValues.length) {
            return {};
        }
        return {
            message_displayed: this.props.vasConfigValues.map(vasTagObj => {
                if (vasTagObj && vasTagObj.title) {
                    return vasTagObj.title.toLowerCase().split(' ').join('_');
                }
                return '';
            }).join(',')
        };
    }

    getListingType = item => {
        if (item?.spotlight_package?.id || isSpotLight(item?.monetizationInfo)) {
            return 'Spotlight';
        }
        else if (isFeatured(item?.monetizationInfo)) {
            return 'Highlight';
        }
        return 'No_focus';
    }

    trackViewItem = () => {
        // When user comes from listing page, origin is set in componentWillUnmount
        // viewItem event is fired from componentDidMount of Item.jsx
        // componentDidMount is called before track origin is updated in state
        // as Item.jsx constructor is called before Listing.jsx componentWillUnmount
        // so stale value of trackOrigin is available in props of component
        // need to figure a proper way to handle origin( from where user lands ) in tracking.
        // JS async nature provides kind of hack for this, till tracking solution is found
        setTimeout(() => {
            const trackInfo = this.getTrackingAttributes(this.props);
            const { marketConfig, params } = this.props;
            const itemIdx = getSessionStorageItem('view_item_idx');

            removeSessionStorageItem('view_item_idx');

            const trackingParams = {
                ...trackInfo,
                ...LayoutHelper.getAcquisitionChannelTrackingValues(),
                ...TrackingHelper.getThematicParams(params, marketConfig?.get()),
                listing_type: this.getListingType(this.props.item)
            };

            if (this.isMxCl && itemIdx) {
                trackingParams.chosen_option = itemIdx;
            }
            this.onTrack(VIEW_ITEM, trackingParams);
        }, 0);
    }

    getLeadformName = (props = this.props) => {
        const { form_config } = props.leadFormConfigData;
        const categoryId = props.item && props.item.category_id;

        // calling lead form API based on the category
        if (form_config && categoryId) {
            const leadFormName = getLeadFormName({
                leadFormActions: this.leadFormActions,
                form_config,
                categoryId: Number(categoryId)
            });

            this.setState({ leadFormName });
        }
    };

    checkIfLoginMandatory = (props = this.props) => {
        const { form_config } = props.leadFormConfigData;
        const categoryId = props.item && props.item.category_id;

        if (form_config && categoryId) {
            const isLoginMandatory = checkIfLoginMandatory(
                {
                    leadFormActions: this.leadFormActions,
                    form_config
                }
            );

            this.setState({ isLoginMandatory });
        }
    }

    wasCalledInAnIframe() {
        if (typeof window !== 'undefined') {
            return window.top.location.href !== window.self.location.href;
        }

        return false;
    }

    toggleReportModal = () => {
        this.setState({
            openReportModal: !this.state.openReportModal
        });
    };

    getTrackingInfo = (props = this.props) => {
        const {
            categoryTreeSelected,
            item,
            user,
            selectedLocation,
            allItemImages
        } = props;

        const { L1, L2 } = categoryTreeSelected || {};
        const { id, category_id } = item || {};

        const trackingInfo = {
            item_id: id,
            category_level1_id: L1 && L1.id,
            category_level2_id: L2 && L2.id,
            images_count: allItemImages.length,
            city_id: getCityLocationId(selectedLocation),
            is_escrow_enable: item?.escrow_details?.is_escrow_enabled === 'enabled'
        };

        if (category_id === this.carsCategory) {
            const adpvTrackingInfo = getItemTrackingInfo(item, user);

            return {
                ...trackingInfo,
                ...adpvTrackingInfo
            };
        }
        return trackingInfo;
    }

    trackImageTap = (trackingInfo = {}, maximize = false) => {
        const eventName = (maximize) ? ITEM_TAP_IMAGE : ITEM_TAP_IMAGE_MINIMIZE;

        this.props.track(eventName, {
            flow_step: FLOW_STEP.GALLERY,
            ...this.getTrackingInfo(),
            ...trackingInfo,
            ...LayoutHelper.getAcquisitionChannelTrackingValues()
        });
    }

    trackImagePagination = (trackingInfo = {}, url, isFullScreen = false) => {
        this.props.track(ITEM_TAP_IMAGE_PAGINATION, {
            flow_step: FLOW_STEP.GALLERY,
            flow_type: isFullScreen ? FLOW_TYPE.FULL_IMAGE_VIEW : FLOW_TYPE.ITEM_PAGE,
            ...this.getTrackingInfo(),
            ...trackingInfo,
            ...LayoutHelper.getAcquisitionChannelTrackingValues()
        });
        this.imageViewed[url] = 1;

        if (isFullScreen) {
            this.fullScreenImageSwipeCount++;
        }
        else {
            this.imageSwipeCount++;
        }
    }

    toggleLoaderState = () => {
        this.setState({
            isLoading: !this.state.isLoading,
            showBookingModal: false
        });
    }

    trackEscrowButton = () => {
        const { item, user, router, loggedUser } = this.props;
        const item_parameter = getItemTrackingInfo(item, user);

        this.props.track(ESCROW_TRACK.ITEM_TAP_BOOKING_RESERVATION, {
            category_id: item?.category_id ?? null,
            flow_type: 'booking',
            item_id: item?.id ?? null,
            is_escrow_enable: item?.escrow_details?.is_escrow_enabled === 'enabled',
            user_category: item_parameter?.user_category
        });
        if (this.props?.item?.escrow_details?.is_escrow_enabled === 'enabled' && this.state.loggedUser?.id !== this.props?.item?.user_id) {
            const { marketConfig: config } = this.props;
            const isMobbiPath = config.get('isOlxMobbi');
            const linkReservationPage = `${isMobbiPath ? `/olxmobbi${ URL.CHECKOUT_BOOKING}` : URL.CHECKOUT_BOOKING}/${slugify(this.props.item.title)}-iid-${this.props.item.id}`;

            router.push(linkReservationPage);
        }
        else {
            this.setState({
                isLoading: true
            });
            this.props.getRelationshipValidation(item.id, loggedUser.id).then(data => {
                if (!data?.data?.isValid) {
                    this.setState({
                        showBookingModal: true,
                        isLoading: false
                    });
                }
                else if (data?.data?.isValid) {
                    this.setState({
                        showAlreadyExistModal: true,
                        isLoading: false
                    });
                }
            })
                .catch(error => {
                    this.setState({
                        isLoading: false
                    });
                    this.props.setToastMessageState({ isOpen: true, message: error, expiration: 5000 });
                });
        }
    }

    onCloseBookingModal = () => {
        this.setState({
            showBookingModal: false,
            showAlreadyExistModal: false
        });
    }

    trackSubmitBookingRequest = () => {
        const { item } = this.props;

        this.props.track('booking_request', {
            flow_type: ESCROW_TRACK.BOOKING,
            category_id: item?.category_id ?? null,
            item_id: item?.id ?? null,
            user_category: isCocoUser(item.user_type) ? 'OLX_Autos' : 'c2c'
        });
    }

    renderBookingModal =() => {
        const { item, loggedUser, sendChatMessage, user } = this.props;
        const { showBookingModal, showAlreadyExistModal } = this.state;

        if (showBookingModal) {
            return (
                <BookingModal onCloseBookingModal={ this.onCloseBookingModal } item={ item } loggedUser={ loggedUser } user={ user } sendChatMessage={ sendChatMessage } toggleLoaderState={ this.toggleLoaderState } trackSubmitBookingRequest={ this.trackSubmitBookingRequest } />
            );
        }
        else if (showAlreadyExistModal) {
            return (
                <AlreadyExistModal onCloseBookingModal={ this.onCloseBookingModal } />
            );
        }
        return null;
    }

    onTrack = (event, props = {}) => {
        const trackProps = {
            ...getFavouriteItemInfo(this.props.item),
            ...this.getTrackingInfo(),
            feed_version: this.props.itemsMetadata.feed_version
        };

        if (trackProps.item_id) {
            this.props.track(event, { ...trackProps, ...props });
        }
    };

    onTrackMap = () => this.onTrack('item_tap_map', this.getTrackingInfo());

    canBeFeatured() {
        return canBeFeatured(this.state.loggedUser, this.props.item);
    }

    getLimitsCard = breakpoint => {
        const { item, category } = this.props;
        const { status, monetizationInfo } = item;
        const displayPostNowCard = status.display === 'limited' && monetizationInfo && monetizationInfo.limits;

        if (displayPostNowCard && !this.lamudiCheck) {
            return (
                <PostNowCard
                    breakpoint={ breakpoint }
                    item={ item }
                    category={ category }
                />
            );
        }

        return null;
    };

    getMonetizerCard = (isNewAdpv = false) => {
        if (!this.canBeFeatured()) {
            return null;
        }
        let monetizerDataCard;
        const { item } = this.props;
        const { views, calls, favorites, monetizationInfo, status } = item;
        const { currentProduct, currentPackage: oldCurrentProduct } = monetizationInfo;
        const currentPackage = currentProduct || oldCurrentProduct;

        if (currentPackage && isSpotLight(monetizationInfo)) {
            monetizerDataCard = (
                <SpotlightAd currentPackage={ currentPackage } />
            );
        }
        else if (currentPackage) {
            monetizerDataCard = (
                <AppliedBoostAd currentPackage={ currentPackage } />
            );
        }
        else {
            monetizerDataCard = (<BoostAd item={ item } isNewAdpv={ isNewAdpv } />);
        }

        return (
            <StatisticsCard
                status={ status }
                views={ views }
                favorites={ favorites.count }
                calls={ calls }
                isNewAdpv={ isNewAdpv }
            >
                {!this.lamudiCheck
                    && monetizerDataCard
                }
            </StatisticsCard>
        );
    };

    getHelmet() {
        const basename = this.props.location.basename ? this.props.location.basename.toLowerCase() : '';
        const helmetProps = {
            link: [
                { rel: 'canonical', href: this.props.marketConfig.get('host') + basename + this.props.location.pathname }
            ]
        };

        return (
            <Helmet { ...helmetProps } />
        );
    }

    onClickReport = () => {
        const loggedUser = Auth.getUser();
        const { trackerOrigins } = this.props;

        this.props.track(ITEM_TAP_REPORT_AD, this.getTrackingInfo());
        if (loggedUser) {
            this.setState({
                loggedUser
            });
            this.toggleReportModal();
        }
        else {
            this.props.setLoginModalState({ state: true, redirectTo: '', trackProps: { origin: trackerOrigins.REPORT_AD }, entryPoint: 0, callback: this.toggleReportModal });
        }
    };

    renderSocialMetaTags(item) {
        const enabled = this.props.marketConfig.get('socialMeta').enabled;

        return (enabled) ? (
            <SocialMetaTags
                title={ item.title }
                description={ item.description }
                path={ this.props.location.pathname }
                image={ item.images[0] ? item.images[0].url : '' }
            />
        ) : false;
    }

    toggleFirstTimeUserTips = initationPoint => {
        this.setState({
            tipsInitiationPoint: typeof initationPoint === 'string' ? initationPoint : this.state.tipsInitiationPoint,
            showTips: !this.state.showTips
        },
        () => {
            if (!this.state.showTips) {
                this.setState({ callFuncStr: this.state.tipsInitiationPoint });
            }
        });
    };

    renderBanners = (slot, customClass = '') => {
        const disabledAdForCocoFofoUser = isCocoFofoUser(this.props.userType);

        if ((disabledAdForCocoFofoUser && this.showModernDesign) || this.isOlxMobbi) {
            return null;
        }

        return (
            <AdvertisingComponent
                slot={ slot }
                page="details"
                category={ this.props.categoryTreeSelected }
                onPlatformChange={ this.handleOnAdsPlatformChange }
                className={ customClass }
            />
        );
    };

    onMessageSend = () => {
        this.setState({
            messageSend: true
        });
    };

    getLocationPath = (addressLimit = ADDRESS_LIMIT) => {
        const { metadata } = this.props.item;
        const locationsObject = metadata
            && metadata.locations
            && metadata.locations.length
            && metadata.locations[0].tree;

        if (locationsObject) {
            return addressComponentsToString(locationsObject, addressLimit);
        }

        return '';
    };

    renderLocationPath = () => {
        return (
            <div className={ css.locationContainer }>
                <span className={ css.location }>
                    {this.getLocationPath()}
                </span>
            </div>
        );
    };

    isMyItem = () => {
        const { item } = this.props;
        const { loggedUser } = this.state;
        const loggedUserId = (loggedUser && loggedUser.id) || '';

        return item && loggedUserId !== '' && loggedUserId === item.user_id;
    };

    isItemOutdated = () => {
        const { item } = this.props;

        return item.status && item.status.display === 'outdated';
    };

    leadFormFlow = (cb, actionName) => {
        if (this.state.isLoginMandatory && !Auth.isLoggedIn()) {
            this.props.setLoginModalState({
                state: true,
                callback: () => {
                    this.leadFormFlow(cb, actionName);
                }
            });
        }
        else {
            this.setState({
                source: actionName,
                actionCallback: cb,
                openLeadFormFlow: true
            });
        }
    };
    resetLeadFormFlowValue = () => {
        this.setState({ openLeadFormFlow: false });
    };
    onLoginCallback = () => {
        this.setState({ loginSuccess: true });
    };
    trackingCallback = event => {
        this.props.track(event, {
            ad_id: this.props.item && this.props.item.id,
            select_from: this.state.leadFormName
        });
    };

    isItemRedirectedToNotFound = () => {
        const { marketConfig, item } = this.props;
        const redirectedToNotFoundStatusForItems = marketConfig.get('redirectedToNotFoundStatusForItems');
        const deprecatedCategories = marketConfig.get('deprecatedCategories');
        const isDeprecatedCategory = getIsCategoryDeprecated(item?.category_id, deprecatedCategories);

        return isDeprecatedCategory || item.status && item.status.status && redirectedToNotFoundStatusForItems.indexOf(item.status.status) >= 0;
    };

    shouldRedirectToNotFound() {
        return this.isMyItem() ? false : this.isItemRedirectedToNotFound();
    }

    toggleActions = action => () => {
        switch (action) {
            case SELLER_ACTIONS.ADD_INSURANCE_DETAILS:
                this.setState({ action: SELLER_ACTIONS.ADD_INSURANCE_DETAILS });
                break;
            default:
                this.setState({ action: null });
                break;
        }
    }

    addInsuranceDetails = item => {
        const updatedItem = { ...item };

        this.props.getItemSeller(res => {
            if (res.ok) {
                const { data } = res;

                if (data.data && data.data.description) {
                    updatedItem.description = data.data.description;
                }
                this.props.editItem(updatedItem, () => {
                    this.props.getItem();
                    this.toggleActions()();
                });
            }
        });
    }

    renderOLXAutosHeader() {
        const { marketConfig: config, item } = this.props;
        const olxAutosConfig = config.get('olxAutos') || {};
        const { showOlxAutosHeader = false } = olxAutosConfig;

        const showHeader = showOlxAutosHeader && (item.category_id === olxAutosConfig.carCategory);

        return showHeader && IS_MOBILE ? <OLXAutosHeaderWrapper /> : null;
    }

    handleMarkCoachClose = () => {
        if (window && window.localStorage) {
            window.localStorage.setItem('reservationCoachMark', true);
        }
        this.setState({ isShowCoachMark: false });
    }

    getRedirectPath(item) {
        if (!item) {
            return '';
        }

        const { marketConfig: config, params: { lang }} = this.props;
        const isMobbiPath = config.get('isOlxMobbi');
        const { id, title } = item;

        return isMobbiPath ? getItemUrlMobbi(id, title, lang) : getItemUrl(id, title, lang);
    }

    render() {
        const { item, structuredData, videoAvailableVariant } = this.props;
        const path = this.props.router.location.pathname;
        const toRedirectPath = this.getRedirectPath(item);
        const ADP_CategoryId = item ? item.category_id : '';
        const showClassifiedsJsonLD = ADP_CategoryId !== this.carsCategory;

        const header = (
            <SearchHeader headerRef={ this.headerRef } categoryId={ ADP_CategoryId } enableSearchInput={ false } loginCallback={ this.onLoginCallback } flowStep={ CAR_COMPARE_FLOW_STEP.ADP } />
        );
        const footer = (<div className={ classNames({ [css.footer]: !this.showMXDesign }) }>
            {this.showMXDesign ? (<Footer sections={ this.props.footer } />) : <Footer />}
        </div>);

        const subHeader = this.showMXDesign ? null : <SubHeader showBackToTop />;

        if (this.props.isFetchingItem) {
            return (
                <Page header={ header } subHeader={ subHeader }>
                    <Breadcrumb className={ classNames(css.breadcrumb, css.important, { [css.mxClStyles]: this.showMXDesign }) } separator={ this.breadcrumbSpearator } />
                    <Placeholder />
                </Page>
            );
        }

        const { params: { slug }, isErrorItem } = this.props;

        if (isErrorItem || !item || this.shouldRedirectToNotFound()) {
            const seoConfig = this.props.marketConfig.get('SEO');
            const noSubHeader = this.showMXDesign || isMobile;

            if ((seoConfig && seoConfig.redirectNotFoundToSearch) && slug) {
                return (
                    <ServerContext
                        status={ statusCodes.MOVED_PERMANENTLY }
                        redirect={ `/items/q-${slug}` }
                    />
                );
            }

            return (
                <ServerContext status={ statusCodes.NOT_FOUND }>
                    <Page header={ header } subHeader={ subHeader } className={ noSubHeader ? css.noResultStyle : css.noResultSubHeaderStyle }>
                        <NoResults />
                    </Page>
                </ServerContext>
            );
        }
        else if (path !== toRedirectPath && typeof window === 'undefined') {
            const querySearch = this.props.app?.location?.search || this.props.location?.search;

            return (
                <ServerContext
                    status={ statusCodes.MOVED_PERMANENTLY }
                    redirect={ `${toRedirectPath}${querySearch}` }
                />
            );
        }

        const phone = item.parameters.find(parameter => {
            return parameter.key === 'phone';
        });

        const parameters = item.parameters.filter(parameter => {
            return parameter.key !== 'phone';
        }) || [];

        const isMyItem = this.isMyItem();
        const isItemOutdated = this.isItemOutdated();
        const showNotifications = isMyItem || (this.enableChat && this.state.messageSend);

        const showInspectionConsentCTA = isMyItem && item.inspection_info && item.inspection_info.consent === INSPECTION_INFO_STATUS.PENDING;

        const olxAutosHeader = this.renderOLXAutosHeader();
        const pageBackgroundColorProp = this.showMXDesign ? BACKGROUND2 : WHITE_TEXT;
        const adpvBannerRedirectionUrl = this.props.marketConfig.get('lamudiBranding', 'adpvBannerRedirectionUrl');

        const akakceBotHiddenTitle = this.props.showAkakceBotHiddenTitle ? getHiddenTitle(item, this.props.user) : '';
        const isLamudi = showLamudiBranding(this.props.marketConfig, ADP_CategoryId);
        const isReservationButton = isReservationButtonActive(
            this.props?.item?.escrow_details?.is_escrow_enabled ?? false,
            this.state.loggedUser?.id ?? null,
            this.props?.item?.user_id ?? null,
            this.props.getEscrowConfig,
            this.props?.item?.category_id ?? null
        );

        return (
            <ServerContext status={ statusCodes.ok }>
                { akakceBotHiddenTitle && <h1 className={ css.akakceTitle }>{akakceBotHiddenTitle}</h1> }
                <Page
                    scrollToTop
                    header={ header }
                    subHeader={ subHeader }
                    footer={ footer }
                    olxAutosHeader={ olxAutosHeader }
                    pageBgColor={ pageBackgroundColorProp }
                >
                    <div data-aut-id="itemComponent"
                        data-test-id={ `adp-variant-${videoAvailableVariant}` }
                        className={ classNames(`${grid.row} ${css.item}`, css.topPromoBanner, css.topPromoNews, {
                            [css.inspectionCTAContainer]: showInspectionConsentCTA,
                            [css.olxAutosHeaderShown]: !!olxAutosHeader
                        }) }
                    >
                        <div className={ classNames({
                            [css.inspectionCTABody]: showInspectionConsentCTA
                        }) }>
                            {showClassifiedsJsonLD && <JsonLd data={ structuredData } />}
                            <Breadcrumb
                                className={ classNames(css.breadcrumb, css.important, { [css.mxClStyles]: this.showMXDesign }) }
                                crumbClassname={ css.crumbClassname }
                                separator={ this.breadcrumbSpearator }
                                links={ this.props.breadcrumbLinks }
                            />
                            {this.getHelmet()}
                            {this.props.item && <ItemSEO
                                page="item"
                                item={ this.props.item }
                                category={ this.props.category }
                                location={ this.props.addressLocation }
                            />}
                            {this.renderSocialMetaTags(item)}
                            {showNotifications && <Notifications
                                item={ item }
                                onTrack={ this.onTrack }
                                messageSend={ this.state.messageSend }
                                updateNoticationMessage={ this.state.updateNoticationMessage }
                            />}
                            {this.enableReportAd && this.state.openReportModal && <ReportModal
                                onClick={ this.toggleReportModal }
                                ID={ this.props.item.id }
                                type="items"
                            />}
                            { !isMobile && showLamudiBranding(this.props.marketConfig, ADP_CategoryId) && (
                                <LamudiBrandingAsync
                                    assetUrl={ LAMUDI_ADPV_BANNER_DESKTOP }
                                    redirectionUrl={ adpvBannerRedirectionUrl }
                                    cssClass={ cssLamudi.listingBanner }
                                />
                            )}
                            {!showInspectionConsentCTA && this.renderBanners('top', css.noMargin)}
                            {!isMobile && !showInspectionConsentCTA && this.renderBanners('left', css.itemPageLeftAd)}
                            <ItemContent
                                item={ item }
                                escrowDetails={ this.props.escrowDetails }
                                isMyItem={ isMyItem }
                                isFullItem={ this.props.isFullItem }
                                isItemOutdated={ isItemOutdated }
                                phone={ phone }
                                parameters={ parameters }
                                location={ this.props.location }
                                user={ this.props.user }
                                getMonetizerCard={ this.getMonetizerCard }
                                getLimitsCard={ this.getLimitsCard }
                                getTrackingInfo={ this.getTrackingInfo }
                                trackImageTap={ this.trackImageTap }
                                trackImagePagination={ this.trackImagePagination }
                                renderBanners={ this.renderBanners }
                                renderLocationPath={ this.renderLocationPath }
                                language={ this.props.marketConfig.get('lang') }
                                onClickReport={ this.onClickReport }
                                toggleFirstTimeUserTips={ this.toggleFirstTimeUserTips }
                                tipsInitiationPoint={ this.state.callFuncStr }
                                onTrack={ this.onTrack }
                                onTrackMap={ this.onTrackMap }
                                onMessageSend={ this.onMessageSend }
                                loggedUser={ this.state.loggedUser }
                                leadFormName={ this.state.leadFormName }
                                leadFormFlow={ this.leadFormFlow }
                                recordItemImpressions={ this.recordItemImpressions }
                                isInspectionPosting={ this.props.isInspectionPosting }
                                toggleActions={ this.toggleActions }
                                actionVal={ this.state.action }
                                addInsuranceDetails={ this.addInsuranceDetails }
                                onViewRelatedAd={ this.handleViewRelatedAd }
                                isLamudi={ isLamudi }
                                isShowReservationButton={ isReservationButton }
                                isShowCoachMark={ this.state.isShowCoachMark } // props for show coachmark when item enabled escrow & user first time visit adpv
                                onCloseMarkCoach={ this.handleMarkCoachClose } // props for show coachmark when item enabled escrow & user first time visit adpv
                                isItemReserved={ item?.escrow_details?.is_reserved === 'reserved' } // disabled button reservation when item is reserved
                                escrowTrack={ this.trackEscrowButton }
                                renderBookingModal={ this.renderBookingModal }
                            />
                            {this.state.isRedirecting && (
                                <Translation id="loading">
                                    {formattedVal => <FullPageLoader text={ formattedVal } className={ css.fullPageLoader } />}
                                </Translation>
                            )
                            }
                            { this.state.isLoading
                                && <FullPageLoader />
                            }
                            {this.enableChat && this.state.showTips && <FirstTimeUserTips
                                toggleModal={ this.toggleFirstTimeUserTips }
                                initationPoint={ this.state.tipsInitiationPoint }
                                origin={ this.props.trackerOrigins.ITEM_PAGE }
                            />}
                            {this.state.leadFormName && <ItemLeadForm
                                item={ item }
                                leadFormName={ this.state.leadFormName }
                                openLeadFormFlow={ this.state.openLeadFormFlow }
                                trackingCallback={ this.trackingCallback }
                                source={ this.state.source }
                                loginSuccess={ this.state.loginSuccess }
                                resetLeadFormFlowValue={ this.resetLeadFormFlowValue }
                                actionCallback={ this.state.actionCallback }
                            />}
                            {
                                this.props.location.hash.includes(trustTagHash) && <TrustTagBottomSheetAsync />
                            }
                        </div>
                    </div>
                </Page>
            </ServerContext>
        );
    }
}

const itemHasError = ({ isError, id, hash, itemsApiVersion }) => {
    if (isError[getUrlType(itemUrls.getItemDetail(id, itemsApiVersion))]) {
        return true;
    }
    return !!(hash && isError[itemUrls.getItem(decryptHash(hash))]);
};

export const mapStateToProps = (state, ownProps) => {
    const item = state.items.elements[ownProps.params.id] || state.bundles.elements[ownProps.params.id];
    const escrowDetails = { escrow_details_seller: state.items.escrow_details_seller };
    const user = (item && state.users.elements[item.user_id]) || {};
    const quickFilters = item && item.category_id ? getQuickFiltersByName(state, item.category_id) : '';

    const shouldShowDentMap = ownProps.marketConfig.get('showDentMap');
    const itemsApiVersion = shouldShowDentMap ? APIVERSION.V3 : APIVERSION.V2;

    return {
        userType: user?.dealer?.car?.dealer_type || '',
        isFetchingItem: isFetchingItemDetail(state, ownProps, itemsApiVersion),
        isErrorItem: itemHasError({
            isError: state.items.isError,
            id: ownProps.params.id,
            hash: ownProps.params.hash,
            itemsApiVersion
        }),
        isFullItem: item && item.is_full,
        item,
        user,
        loggedUser: getUserDataSelector(state),
        vasConfigValues: getVasConfigValues(state, item && item.value_added_services || []),
        quickFilters,
        categoryTreeSelected: item ? getCategoryTree(state.categories.elements, item['category_id']) : null,
        category: getCategoryElement(state, { ...ownProps, categoryId: item && item.category_id }),
        config: configSelector(state),
        meta: userId => state.users.collections[userUrls.getMeta(userId)],
        trackFilters: state.track.filters,
        trackFiltersMetadata: state.track.filtersMetadata,
        trackOrigin: state.track.origin,
        filterInteraction: state.track.filterInteraction,
        addressLocation: getLocationByLatLongFromCollection(state, getLatLon(item)),
        breadcrumbLinks: itemBreadcrumbSelector(state, ownProps),
        itemsMetadata: itemsMetadataSelector(state, ownProps),
        selectedLocation: selectedLocationSelector(state),
        autocomplete: state.autocomplete,
        leadFormConfigData: leadFormConfigSelector(state),
        structuredData: getItemStructuredData(state, ownProps),
        isAdSuggested: !!(ownProps.location.state && ownProps.location.state.isAdSuggested),
        selectFrom: (ownProps.location.state && ownProps.location.state.source),
        isInspectionPosting: state.inspectionConsent.isInspectionPosting,
        browseMode: state.track.browsingMode,
        recommendations: item ? recommendationsSelector(state, { ...ownProps, item, loggedUser: Auth.getUser() }) : [],
        trafficOrigin: LayoutSelector.getTrackingOrigin(state, ownProps.location, ownProps.marketConfig),
        source: ownProps.location.state?.source,
        allItemImages: selectAdpvGalleryImages(state, ownProps),
        adpvFeatureStatus: adpvFeatureStatusSelector(state, ownProps),
        showAkakceBotHiddenTitle: state.serverContext.showAkakceBotHiddenTitle,
        videoAvailableVariant: state.videoAvailableVariant?.variant || '',
        getEscrowConfig: getEscrowConfig(state),
        escrowDetails
    };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
    const shouldShowDentMap = ownProps.marketConfig.get('showDentMap');
    const itemsApiVersion = shouldShowDentMap ? APIVERSION.V3 : APIVERSION.V2;

    return {
        getItem: (itemId = ownProps.params.id) => dispatch(getItem(itemId, itemsApiVersion, ownProps.marketConfig.get('lang'))),
        getMeta: userId => dispatch(get(userUrls.getMeta(userId), 'USERS')),
        getItemAd: (itemId = ownProps.params.id) => dispatch(get(itemUrls.getItem(itemId), 'GET_DETAIL_ESCROW')),
        setLoginModalState: state => dispatch(setLoginModalState(state)),
        setOriginTrack: origin => dispatch(setOriginSync(origin)),
        setFlowStepTrack: flowStep => dispatch(setFlowStep(flowStep)),
        editItem: (item, callback) => dispatch(put(itemUrls.editItem(item.id), 'ELEMENT_ITEMS', {
            data: item
        }, {})).then(res => callback(res)),
        getItemSeller: callback => dispatch(get(itemUrls.getItem(ownProps.params.id), 'ELEMENT_ITEMS')).then(res => callback(res)),
        fetchEscrowConfiguration: () => dispatch(fetchEscrowConfiguration()),
        getRelationshipValidation: (adId, buyerId) => dispatch(get(itemUrls.getRelationshipValidation(adId, buyerId), 'RELATIONSHIP')),
        setToastMessageState: state => dispatch(setToastMessageState(state))
    };
};

export default compose(
    withRouter,
    withConfig('marketConfig'),
    withLocation,
    withMessage,
    withTrack,
    withDataFetching(dispatch => dispatch(getNavigationTree())),
    withTags('listings', routerParamsToSeoQuery),
    connect(mapStateToProps, mapDispatchToProps),
    withSchema('Product')
)(Item);
